// extracted by mini-css-extract-plugin
export default {"root":"Select_root__Gqx23","select":"Select_select__aeuTF","openedSelect":"Select_openedSelect__+tMYh","dropdown":"Select_dropdown__P56Tv","option":"Select_option__a4nLv"};